<template>
    <div>
        <div v-if="arrCampaignImage && arrCampaignImage.length > 1">
            <carousel
                :responsive="objCarouselConfig.responsive"
                :margin="10"
                :lazyLoad="true"
                :loop="true"
                :autoplay="true"
            >
                <div
                    class="detail-img-rotate"
                    v-for="(objImage, k) in arrCampaignImage"
                    :key="k"
                >
                    <img :src="objImage.fullImageUrl" class="img-fluid" />
                </div>
            </carousel>
        </div>
        <div
            class="detail-img"
            v-if="arrCampaignImage && arrCampaignImage.length == 1"
        >
            <img :src="arrCampaignImage[0].fullImageUrl" />
        </div>
    </div>
</template>

<script>
import Carousel from "vue-owl-carousel";

export default {
    name: "Picture",
    components: {
        Carousel
    },
    props: {
        arrCampaignImage: Array
    },
    data: function() {
        return {
            objCarouselConfig: {
                responsive: {
                    0: { items: 1 }
                }
            }
        };
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
.detail-img {
    position: relative;
    width: 100%; /* desired width */
    img {
        @extend %content-shadow;
        width: 100%;
        height: 100%;
        position: absolute;
        border-radius: 15px;
        top: 0;
        left: 0;
    }
}

.detail-img:before {
    content: "";
    display: block;
    padding-top: 56.66%; /* initial ratio of 1:1*/
}
</style>
